import Moment from "moment";

export const LocalizedDate = ({ date }) => {
  const d = date ? Moment(date).format("D.M.YYYY") : "-";
  return <span>{d}</span>;
};

export const LocalizedDateTime = ({ datetime }) => {
  const d = datetime ? Moment(datetime).format("D.M.YYYY [klo] HH:mm") : "-";
  return <span>{d}</span>;
};
